import { type EELPFCOption, type Option } from '../types/eelPfc.type';

export const EEL_PFC_OPTION = {
  AESITN: 'AES_ITN',
  NOEEI3036: 'NOEEI_30_36',
  NOEEI3037A: 'NOEEI_30_37_a',
  NOEEI3037F: 'NOEEI_30_37_f',
  NOEEI3037H: 'NOEEI_30_37_h',
} as const;

const NOEEI_30_37_A_OPTION: Option<EELPFCOption> = {
  label: 'NOEEI 30 37(a)',
  value: EEL_PFC_OPTION.NOEEI3037A,
};

const NOEEI_30_37_F_OPTION: Option<EELPFCOption> = {
  label: 'NOEEI 30 37(f)',
  value: EEL_PFC_OPTION.NOEEI3037F,
};

const NOEEI_30_37_H_OPTION: Option<EELPFCOption> = {
  label: 'NOEEI 30 37(h)',
  value: EEL_PFC_OPTION.NOEEI3037H,
};

const NOEEI_30_36_OPTION: Option<EELPFCOption> = {
  label: 'NOEEI 30 36',
  value: EEL_PFC_OPTION.NOEEI3036,
};

const AES_ITN_OPTION: Option<EELPFCOption> = {
  label: 'AES / ITN',
  value: EEL_PFC_OPTION.AESITN,
};

export const OPTIONS: Option<EELPFCOption>[] = [
  NOEEI_30_37_A_OPTION,
  NOEEI_30_37_F_OPTION,
  NOEEI_30_37_H_OPTION,
  NOEEI_30_36_OPTION,
  AES_ITN_OPTION,
];
